// generated by genversion
export var version = '4.2.1';
//# sourceMappingURL=version.js.map